import * as actionCreators from './actionCreators';
import { ActionTypeNames } from './actions';

type Actions = ReturnType<typeof actionCreators[keyof typeof actionCreators]>;

export interface State {
    loadingTaskCount: number;
}

const initialState: State = {
    loadingTaskCount: 0
};

export default function reducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionTypeNames.StartLoading:
            return {
                ...state,
                loadingTaskCount: state.loadingTaskCount + 1
            };
        case ActionTypeNames.EndLoading:
            return {
                ...state,
                loadingTaskCount: state.loadingTaskCount - 1
            };
        default:
            return state;
    }
}
